<div class="toolbar-container no-select space-between">
  <ul class="flex-navbar left-navbar">
    <li>
      <img class="openground-logo" src="assets/icons/openground.png" />
    </li>
    <li role="separator">
      <div class="separator"></div>
    </li>
    <li>
      <h3 class="openground-title">OpenGround Cloud</h3>
    </li>
  </ul>

  <ul class="flex-navbar right-navbar">
    <li class="hf-iconButton" id="HFHelpButton">
      <a
        id="HFHelpUrl"
        title="Help"
        href="https://communities.bentley.com/products/geotechnical1/w/openground-wiki"
        target="_blank"
      >
        <img
          class="community-help-image"
          src="assets/icons/community-help.svg"
        />
      </a>
    </li>
    <li id="cloudNameTab">
      <span id="cloudname" class="hf-navbar-text"> {{ cloudName }} </span>
    </li>
    <li id="nameTab">
      <span id="username" class="hf-navbar-text"
        > {{ fullName }}</span
      >
    </li>
    <li id="HFProfileTab">
      <div
        class="dropdown initialsBadge dropDownFadeContainer"
        [ngClass]="{ open: profileDropDownOpen }"
      >
        <span id="userInitialsIcon" class="text-center">{{ initials }}</span
        ><a
          #popup
          class="hf-dropdown-toggle"
          id="HFProfileAnchor"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          (click)="toggleProfileDropDownOpen()"
          (window:mouseup)="onMouseUp($event)"
        >
          <span class="caret"></span
        ></a>
        <ul class="hf-dropdown-menu fade">
          <li>
            <div class="profile-details">
              <div class="name" id="HFProfileName">{{ fullName }}</div>
              <div class="email" id="HFEmail">{{ email }}</div>
            </div>
          </li>
          <li role="separator" class="divider"></li>
          <li *ngIf="changeCloudVisible">
            <a target="_blank" (click)="onChangeCloud()"
              >Change Cloud
            </a>
          </li>
          <li>
            <a *ngIf="logoutVisible" id="HFSignOut" (click)="onSignOff()"
              >Sign Out
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
